import { identity } from 'ramda';
import React from 'react';
import { Row, Col, Label } from 'reactstrap';
import Constants from '../../../Constants';

const { layoutGridSize, formLabelSize, formLabelSizeSm } = Constants;

class SelectInput extends React.Component {
  onChange = (value) => {
    const valueParse = this.props.idOption ? value : JSON.parse(value);
    this.props.onInputChange(this.props, valueParse.id, valueParse);
  };

  renderOptions(inputFields) {
    if (inputFields.dataObj.length) {
      const dataObj = [...inputFields.dataObj];

      if (inputFields.defaultValue) {
        dataObj.unshift({ id: '', name: 'Choose...' });
      }

      const options = dataObj.map((obj) => {
        const valueOption = inputFields.idOption ? obj.id : JSON.stringify(obj);
        return (
          <option key={`id-${valueOption}`} value={valueOption}>
            {obj.name}
          </option>
        );
      });

      return options;
    } else {
      return '';
    }
  }

  render() {
    const inputFields = this.props;
    const { required, labelSize = formLabelSize, keepLabelTopAligned = true } = this.props;
    const controlSize = layoutGridSize - labelSize || layoutGridSize;
    const controlSizeSm = layoutGridSize - formLabelSizeSm;

    const errorClass = this.props.errorMessages ? 'border-error' : '';
    const error = this.props.errorMessages;

    return (
      <div ref={inputFields.refProps} className={inputFields.classNames}>
        <Row
          className={['lsn-form-label-control relative', keepLabelTopAligned ? null : 'v-middle-align']
            .filter(identity)
            .join(' ')}>
          <Label
            for={inputFields.name}
            sm={formLabelSizeSm}
            md={labelSize}
            className={['lsn-form-label ScalaSansOT', keepLabelTopAligned ? 'mTop-6' : null]
              .filter(identity)
              .join(' ')}>
            {required ? <span className="lsn-red pRight-3">*</span> : void 0}
            {inputFields.title}
          </Label>
          <Col sm={controlSizeSm} md={controlSize} className={'input-left relative dropdown-icon'}>
            {inputFields.idOption && (
              <select
                id={inputFields.name}
                data-testid={inputFields.name}
                className={[errorClass, 'input'].filter(identity).join(' ')}
                onChange={(evt) => this.onChange(evt.target.value)}
                value={inputFields.value}>
                {this.renderOptions(inputFields)}
              </select>
            )}
            {!inputFields.idOption && inputFields.isEdit && (
              <select
                id={inputFields.name}
                data-testid={inputFields.name}
                className={[errorClass, 'input'].filter(identity).join(' ')}
                onChange={(evt) => this.onChange(evt.target.value)}
                value={inputFields.value}>
                {this.renderOptions(inputFields)}
              </select>
            )}
            {!inputFields.idOption && !inputFields.isEdit && (
              <select
                id={inputFields.name}
                data-testid={inputFields.name}
                className={[errorClass, 'input'].filter(identity).join(' ')}
                onChange={(evt) => this.onChange(evt.target.value)}>
                {this.renderOptions(inputFields)}
              </select>
            )}
            <div className="height-25 v-align-top">
              <span
                hidden={!error}
                className="input-error"
                role="alert">{`${inputFields.title} can not be empty`}</span>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default SelectInput;
